import { useContext } from 'react';

import Body2 from 'components/Body2';
import Icon from 'components/Icon';
import ListItem from 'components/ListItem';
import Phone from 'components/Phone';
import Text from 'components/Text';

import phoneContext from 'contexts/phone';

import arrow from './images/arrow.svg';

import styles from './styles.module.scss';

const PhoneListItem = () => {
    const { phone } = useContext(phoneContext);

    const { hours = '', number = '', text = '' } = phone;

    if (!number) {
        return '';
    }

    return (
        <ListItem className={styles.listItem}>
            <div className={styles.desktopStyle}>
                <Phone className={styles.phone} number={number} text={number} />
                <Icon
                    alt="Down arrow"
                    className={styles.phoneIcon}
                    image={arrow}
                />

                <div className={styles.phoneDetailsBox}>
                    <Phone
                        className={styles.phoneOne}
                        number={number}
                        text={text}
                    />
                    <Text className={styles.textOne} text={hours} />
                </div>
            </div>

            <div className={styles.mobileStyle}>
                <Phone
                    className={styles.phoneTwo}
                    number={number}
                    text={text}
                />

                <div className={styles.container}>
                    <Body2 className={styles.hourText} text={hours} />
                </div>
            </div>
        </ListItem>
    );
};

export default PhoneListItem;
